import { Component, ElementRef, Input, ViewChild, AfterViewInit, OnDestroy, ChangeDetectorRef, Inject, PLATFORM_ID } from '@angular/core';
import { BannerCardComponent } from '../banner-card/banner-card.component';
import { RouterModule } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronCircleRight, faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-banner-slider',
  imports: [RouterModule,CommonModule,FontAwesomeModule],
  templateUrl: './banner-slider.component.html',
  styleUrl: './banner-slider.component.scss'
})
export class BannerSliderComponent implements AfterViewInit, OnDestroy {

  constructor(private cdr: ChangeDetectorRef, @Inject(PLATFORM_ID) private platformId: Object) {}

  @Input() title = "";
  @Input() titleColor = "#000";
  @Input() cssClassTitle = "";
  @Input() url = "";
  @Input() link = "";
  @Input() linkText = "";
  @Input() cssClassLinkText = "";
  @Input() id = "";
  faCircleChevronRight = faChevronCircleRight;
  faCircleChevronLeft = faChevronCircleLeft;



  @ViewChild('box', { read: ElementRef })  widgetsContent!: ElementRef<any>;

  leftScrollBtnActive = false;
  rightScrollBtnActive = true;
  cardWidth = 285 + 30; //width + marginRight

  private _mutationObserver?: MutationObserver;

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this._mutationObserver = new MutationObserver(() => {
      requestAnimationFrame(() => {
        this.updateScrollBtnState();
        this.cdr.detectChanges();
      });
    });
    this._mutationObserver.observe(this.widgetsContent.nativeElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }

  ngOnDestroy(): void {
    this._mutationObserver?.disconnect();
  }

  private updateScrollBtnState(): void {
    const el = this.widgetsContent.nativeElement;
    this.leftScrollBtnActive = el.scrollLeft > 0;
    this.rightScrollBtnActive = el.scrollLeft < (el.scrollWidth - el.offsetWidth - 1);
  }

  slideRight(){

    this.widgetsContent.nativeElement.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft + this.cardWidth), behavior: 'smooth' });
    this.leftScrollBtnActive = true;
    
    if(this.widgetsContent.nativeElement.scrollLeft >= (this.widgetsContent.nativeElement.scrollWidth- this.widgetsContent.nativeElement.offsetWidth-this.cardWidth))
    {
      this.rightScrollBtnActive = false;
    }
  }

  slideLeft(){
    this.rightScrollBtnActive = true;

    this.widgetsContent.nativeElement.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft - this.cardWidth), behavior: 'smooth' });

    if(this.widgetsContent.nativeElement.scrollLeft <= this.cardWidth)
    {
      this.leftScrollBtnActive = false;
    }
  }

}
